import React, { Component } from 'react';
import { Link } from "react-router-dom";
import {
    AnimatePresence,
    motion,
    useTransform,
    useViewportScroll,
} from "framer-motion";
import {
    Icon,
    ListItem,
    Navbar,
    Link as LinkUI,
    Container,
    NavbarSticky,
} from 'uikit-react';
import { Email } from "react-obfuscate-email";

import logo from '../assets/images/logo.svg';

window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
    document.getElementById("header").style.fontSize = "12px";
  } else {
    document.getElementById("header").style.fontSize = "14px";
  }
}

class Header extends Component {
    render() {
        // toggleMenu comes from App as a prop
        const { toggleMenu } = this.props;

        return (
            <NavbarSticky options="cls-inactive: uk-navbar-transparent ">

                <Container>
                    <div className='uk-grid header'>
                        <div className="uk-width-1-1@s uk-text-center uk-width-1-3">
                            <Link className="" to='/'>
                                <img className="logo" src={logo} width="100" height="46" alt="Scott Bamford" />
                            </Link>
                        </div>

                        {/* Mobile hamburger */}
                        <Navbar right className="uk-hidden@s uk-width-2-3 uk-flex-right uk-text-right">
                            <button 
                                className="ui-button" 
                                onClick={toggleMenu}   // now opens Offcanvas menu
                            >
                                🍔 &nbsp;
                            </button>
                        </Navbar>
                    </div>
                </Container>

            </NavbarSticky>
        );
    }
}

export default Header;
